export default __webpack_public_path__ + "static/media/chevron-down.a46bdfcc.svg";